/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Playlist } from './Playlist';
import {
    PlaylistFromJSON,
    PlaylistFromJSONTyped,
    PlaylistToJSON,
} from './Playlist';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Related
 */
export interface Related {
    /**
     * 
     * @type {Array<User>}
     * @memberof Related
     */
    users?: Array<User>;
    /**
     * 
     * @type {Array<Track>}
     * @memberof Related
     */
    tracks?: Array<Track>;
    /**
     * 
     * @type {Array<Playlist>}
     * @memberof Related
     */
    playlists?: Array<Playlist>;
}

/**
 * Check if a given object implements the Related interface.
 */
export function instanceOfRelated(value: object): value is Related {
    let isInstance = true;

    return isInstance;
}

export function RelatedFromJSON(json: any): Related {
    return RelatedFromJSONTyped(json, false);
}

export function RelatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Related {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': !exists(json, 'users') ? undefined : ((json['users'] as Array<any>).map(UserFromJSON)),
        'tracks': !exists(json, 'tracks') ? undefined : ((json['tracks'] as Array<any>).map(TrackFromJSON)),
        'playlists': !exists(json, 'playlists') ? undefined : ((json['playlists'] as Array<any>).map(PlaylistFromJSON)),
    };
}

export function RelatedToJSON(value?: Related | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users === undefined ? undefined : ((value.users as Array<any>).map(UserToJSON)),
        'tracks': value.tracks === undefined ? undefined : ((value.tracks as Array<any>).map(TrackToJSON)),
        'playlists': value.playlists === undefined ? undefined : ((value.playlists as Array<any>).map(PlaylistToJSON)),
    };
}

